import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { userApi } from "../../backend_urls/userApi";
import AutoClosePopup, { TitleType } from "../../components/popups/AutoClosePopup";
import { UserURL } from "../../routes/user_routes/UserURL";

const UploadDocument = () => {
    const { token } = useParams();
    const source = new URLSearchParams(window.location.search).get("source") || "platform";

    const navigate = useNavigate();

    const [document, setDocument] = useState(null);
    const [file, setFile] = useState(null);

    const [loading, setLoading] = useState(true);
    const [popup, setPopup] = useState({
        open: false,
        type: "",
        title: "",
        message: ""
    });
 
    useEffect( () => {
        const fetchDocument = async () => {
            if (!token) return;
            if (!source) return;
            try {
                setLoading(true);
                const response = await userApi.validateRequestedDocument(token);
                const data = response.data;
                if (data.already_uploaded) {
                    showMessage(
                        TitleType.INFO,
                        "Document Already Uploaded",
                        "You have already uploaded the requested document. Your CA will review it shortly."
                    );
                    return;
                }

                setDocument(data);
            } catch (error) {
                showMessage(
                    TitleType.ERROR,
                    "Invalid Link",
                    error.response?.data?.detail || "Invalid or expired link"
                );
            } finally { setLoading(false); }
        };
        fetchDocument();
    },[token, source]);

    const showMessage = (type, title, message) => {
        setPopup({ open: true, type, title, message });
    };

    const uploadDocument = async()=>{
        if(!file){
            showMessage(
                TitleType.ERROR,
                "Missing File",
                "Please select a file before uploading.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        try {
            setLoading(true);
            await userApi.uploadRequestedDocument(token, source, formData);
            showMessage(
                "success",
                "Success",
                "Your document has been uploaded successfully."
            );
        }
        catch(error){
            showMessage(
                TitleType.ERROR,
                "Upload Failed",
                error.response?.data?.detail || "Upload failed."
            );
        } finally { setLoading(false); }
    }

    if(loading) return <h3>Checking link...</h3>

    return (
        <>
            <div>
                <h2>Upload Document</h2>
                <p>CA: {document.ca_name}</p>
                <p>Document: {document.title}</p>
                <p>Type: {document.document_type}</p>
                <p>Due Date: {document.due_date}</p>

                <input
                    type     = "file"
                    onChange = { e => setFile(e.target.files[0]) }
                />

                <button onClick={ uploadDocument }>Upload</button>
            </div>

            <AutoClosePopup
                isOpen  = { popup.open }
                type    = { popup.type }
                title   = { popup.title }
                onClose={() => {
                    setPopup(prev => ({ ...prev, open: false }));

                    if (document?.already_uploaded) {
                        navigate(UserURL.USER_DASHBOARD);
                    }
                }}
            >
                <p>{ popup.message }</p>
            </AutoClosePopup>
        </>
    )
}

export default UploadDocument;
